import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/audit';

/**
 * Sticky bottom CTA that appears once the visitor has scrolled past the hero CTA.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <div className={['fixed inset-x-0 bottom-0 z-50 px-3 pb-3 pt-2', 'bg-gradient-to-t from-navy-950/90 to-transparent', 'transition-[opacity,transform] duration-200 ease-out', visible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'].join(' ')} data-id="element-169" data-mp="2avkz6piral0g">
      <a href={CHECKOUT_URL} aria-hidden={!visible} tabIndex={visible ? 0 : -1} className={['mx-auto flex w-full max-w-lg items-center justify-center gap-2 rounded-2xl bg-gold-500 px-5 py-4', 'text-center text-sm font-extrabold uppercase leading-tight tracking-wide text-navy-950 sm:text-base', 'shadow-[0_12px_36px_-8px_rgba(0,0,0,0.6)] hover:bg-gold-400', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white', visible ? 'animate-shake-cta' : ''].join(' ')} data-id="element-170" data-mp="2z2r2y8fzi14x">
        Get the Audit — $27
        <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-171" data-mp="2bc3lavg9nx56" />
      </a>
    </div>;
}